'use client';

import React, { useCallback, useRef } from 'react';
import { BottomSheet } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import type { AvailableUpgradeTargetItem } from '../../services/api';
import { UpgradeTargetList } from './UpgradeTargetList';
import { useUpgradeTargetFilters } from './useUpgradeTargetFilters';
import translations from './UpgradeScreen.translations';

interface UpgradeTargetSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectItem: (item: AvailableUpgradeTargetItem) => void;
  sourceItemId: string | null;
  sourceAmount?: number | null;
}

export const UpgradeTargetSheet: React.FC<UpgradeTargetSheetProps> = ({
  isOpen,
  onClose,
  onSelectItem,
  sourceItemId,
  sourceAmount = null,
}) => {
  const { t } = useLocalTranslation(translations);
  const { filtersNode, queryFilters } = useUpgradeTargetFilters();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleSelect = useCallback((item: AvailableUpgradeTargetItem) => {
    onSelectItem(item);
    onClose();
  }, [onSelectItem, onClose]);

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('selectTarget')}
      headerAccessory={filtersNode}
      scrollRef={scrollRef}
    >
      <UpgradeTargetList
        sourceItemId={sourceItemId}
        sourceAmount={sourceAmount}
        queryFilters={queryFilters}
        onSelectItem={handleSelect}
        scrollRef={scrollRef}
      />
    </BottomSheet>
  );
};
